import { composeFieldPath } from '@northfork/basics'
export const cashField = composeFieldPath([] as CashEntryModel[])

export interface CashEntryRow {
  account: string
  category: string
  entryDate: string
  settleDate: string
  postDate: string
  cusip: string
  cwanIdentifier?: string
  currency: string
  amount: string
  inventoryType?: string
  feeType?: string
  collateralBroker?: string
  foreignTaxOriginalEventDate?: string
  recallableCommitmentAffect?: string
  navAffect?: string
  fundedCommitmentAffect?: string
  totalCommitmentAffect?: string
  dataSource?: string
  isCapitalize?: string
  prepaidInterest?: string
  loanFeeType?: string
  balanceToAdjust?: string
  exitFee?: number
  exitFeeReceivable?: number
  prepaymentPenaltyFee?: number
  delinquencyFee?: number
  modificationFee?: number
  miscellaneousFee?: number
  interestBearingInterestReserve?: number
  interestBearingPrincipalReserve?: number
  nonInterestBearingInterestReserve?: number
  nonInterestBearingPrincipalReserve?: number
}

export interface CashEntryData {
  cashEntry: CashEntryRow
  notes: string
  clearTransaction: boolean
}

export interface CashEntryModel {
  id: keyof CashEntryRow
  validityStatus: 'valid' | 'invalid' | 'warning'
  isEditable: boolean
  type: 'number' | 'string' | 'date'
  field: string
  value: string
  custody?: string
  trading?: string
  errorMessage?: string
  currency?: string
}

/**
 * Represents input values that we should pre-populate the modal with.
 *  This is a view model.
 */
export interface CashEntryInputModel {
  tranTypeCode?: string
  entryDate?: string // ISO8601 full date
  settleDate?: string // ISO8601 full date
  postDate?: string // ISO8601 full date
  amount?: string // should be formatted decimal
  securityId?: string
  secId?: number
  accountId?: number
  note?: string //pre-populated note
  currency?: string
  fromDistribution?: boolean
  collateralBroker?: string
  prepaidInterest?: number
  exitFee?: number
  prepaymentPenaltyFee?: number
  delinquencyFee?: number
  modificationFee?: number
  miscellaneousFee?: number
}
